import { TemplateRef } from '@angular/core';
import moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SelfScanTrendModalComponent } from '../../../shared/wellbeing-result/self-scan-trend/self-scan-trend-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i3 from "@angular/common";
import * as i4 from "@angular/router";
const _c0 = ["progressModal"];
function WellbeingResultCardComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 26);
} }
function WellbeingResultCardComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
} }
function WellbeingResultCardComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
} }
function WellbeingResultCardComponent_span_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 29);
} }
function WellbeingResultCardComponent_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
} }
function WellbeingResultCardComponent_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 31);
} }
export class WellbeingResultCardComponent {
    constructor(modalService) {
        this.modalService = modalService;
        this.modalOptions = { windowClass: 'modal-window', size: 'lg', centered: true };
    }
    set srqHistory(value) {
        this._srqHistory = value;
        if (value && value.length) {
            this.latestSrq = value[value.length - 1];
            this.totalScore = this.latestSrq.score;
            this.determineTotalScoreStage(this.totalScore);
        }
    }
    ngOnInit() {
        // this.totalScore = 20;
        // this.determineTotalScoreStage(this.totalScore);
    }
    dateFormatted(date) {
        return moment(date).format('HH:mm, D MMM, YYYY');
    }
    determineTotalScoreStage(totalScore) {
        this.isAtRisk = false;
        this.isAtTough = false;
        this.isResilient = false;
        if (totalScore <= 3) {
            this.isAtTough = true;
        }
        else if (totalScore >= 4 && totalScore <= 13) {
            this.isAtRisk = true;
        }
        else if (totalScore >= 14) {
            this.isResilient = true;
        }
    }
    openProgressModal() {
        this.progressModalReference = this.modalService.open(SelfScanTrendModalComponent, this.modalOptions);
        this.progressModalReference.componentInstance.selfScanModalRef = this.progressModalReference;
        this.progressModalReference.componentInstance.srqHistory = this._srqHistory;
    }
}
WellbeingResultCardComponent.ɵfac = function WellbeingResultCardComponent_Factory(t) { return new (t || WellbeingResultCardComponent)(i0.ɵɵdirectiveInject(i1.NgbModal)); };
WellbeingResultCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingResultCardComponent, selectors: [["wellbeing-result-card"]], viewQuery: function WellbeingResultCardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.progressModal = _t.first);
    } }, inputs: { srqHistory: "srqHistory" }, decls: 30, vars: 20, consts: [[1, "card"], [1, "card-body"], [1, "d-flex", "justify-content-between", "align-items-center"], ["jhiTranslate", "inukaNgApp.indexUser.wellbeingResult.title"], [1, "text-light"], [1, "progress-link", 3, "click"], [2, "height", "1.1rem!important", "width", "1.3rem!important"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#progress"], ["jhiTranslate", "inukaNgApp.indexUser.wellbeingResult.progress", 1, "progress-text"], [1, "row", "mt-3", "border", "border-2"], [1, "col-12", "col-lg-3", "p-2", "text-center"], [1, "d-inline", "d-lg-block", "text-center"], [1, "text-white", "d-inline"], ["jhiTranslate", "wellBeingResult.stages.atTough.title", 4, "ngIf"], ["jhiTranslate", "wellBeingResult.stages.atRisk.title", 4, "ngIf"], ["jhiTranslate", "wellBeingResult.stages.resilient.title", 4, "ngIf"], [1, "d-inline", "d-lg-block", "text-white", "ml-3", "ml-lg-0"], [1, "h2", "text-white"], [1, "h5", "text-white"], [1, "col-12", "col-lg-9", "p-3", "p-lg-0"], ["class", "wellbeing-stage-description px-lg-3", "jhiTranslate", "wellBeingResult.stages.atTough.description1", 4, "ngIf"], ["class", "wellbeing-stage-description px-lg-3", "jhiTranslate", "wellBeingResult.stages.atRisk.description1", 4, "ngIf"], ["class", "wellbeing-stage-description px-lg-3", "jhiTranslate", "wellBeingResult.stages.resilient.description1", 4, "ngIf"], [1, "row", "mt-3", "justify-content-center"], ["routerLink", "/wellbeing-result", "jhiTranslate", "inukaNgApp.indexUser.wellbeingResult.viewDetails", 1, "btn", "btn-link", "m-2"], ["routerLink", "/wellbeing-start", "jhiTranslate", "inukaNgApp.indexUser.wellbeingResult.newSelfScan", 1, "btn", "btn-secondary", "ml-lg-3"], ["jhiTranslate", "wellBeingResult.stages.atTough.title"], ["jhiTranslate", "wellBeingResult.stages.atRisk.title"], ["jhiTranslate", "wellBeingResult.stages.resilient.title"], ["jhiTranslate", "wellBeingResult.stages.atTough.description1", 1, "wellbeing-stage-description", "px-lg-3"], ["jhiTranslate", "wellBeingResult.stages.atRisk.description1", 1, "wellbeing-stage-description", "px-lg-3"], ["jhiTranslate", "wellBeingResult.stages.resilient.description1", 1, "wellbeing-stage-description", "px-lg-3"]], template: function WellbeingResultCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "h3", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "a", 5);
        i0.ɵɵlistener("click", function WellbeingResultCardComponent_Template_a_click_6_listener() { return ctx.openProgressModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(7, "svg", 6);
        i0.ɵɵelement(8, "use", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(9, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelementStart(13, "h4", 12);
        i0.ɵɵtemplate(14, WellbeingResultCardComponent_span_14_Template, 1, 0, "span", 13);
        i0.ɵɵtemplate(15, WellbeingResultCardComponent_span_15_Template, 1, 0, "span", 14);
        i0.ɵɵtemplate(16, WellbeingResultCardComponent_span_16_Template, 1, 0, "span", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 16);
        i0.ɵɵelementStart(18, "span", 17);
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(20, "/");
        i0.ɵɵelementStart(21, "span", 18);
        i0.ɵɵtext(22, "20");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 19);
        i0.ɵɵtemplate(24, WellbeingResultCardComponent_span_24_Template, 1, 0, "span", 20);
        i0.ɵɵtemplate(25, WellbeingResultCardComponent_span_25_Template, 1, 0, "span", 21);
        i0.ɵɵtemplate(26, WellbeingResultCardComponent_span_26_Template, 1, 0, "span", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 23);
        i0.ɵɵelement(28, "a", 24);
        i0.ɵɵelement(29, "button", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.dateFormatted(ctx.latestSrq == null ? null : ctx.latestSrq.dateTaken));
        i0.ɵɵadvance(5);
        i0.ɵɵclassProp("border-danger", ctx.isAtTough)("border-warning", ctx.isAtRisk)("border-success", ctx.isResilient);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("bg-danger", ctx.isAtTough)("bg-warning", ctx.isAtRisk)("bg-success", ctx.isResilient);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isAtTough);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAtRisk);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isResilient);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.totalScore);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isAtTough);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAtRisk);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isResilient);
    } }, directives: [i2.JhiTranslateDirective, i3.NgIf, i4.RouterLinkWithHref, i4.RouterLink], styles: [".wellbeing-stage-description[_ngcontent-%COMP%]{position:absolute;top:50%;margin-top:-0.5rem}h3[_ngcontent-%COMP%]{margin-bottom:0}.progress-link[_ngcontent-%COMP%]{margin-left:.5rem;background-color:#fff;color:#44a38d}.progress-text[_ngcontent-%COMP%]{color:#44a38d;font-weight:bold;display:none;padding-left:3px}@media(min-width: 768px){.progress-text[_ngcontent-%COMP%]{display:inline}}@media(min-width: 992px){.progress-text[_ngcontent-%COMP%]{display:none}}@media(min-width: 1200px){.progress-text[_ngcontent-%COMP%]{display:inline}}"] });
